import styled from "@emotion/styled";
export const StyledVerticalTabsComponent = styled.div``;
